// import { useEffect, useState } from "react";
// import { reconcilePoItem } from "src/services/po-api";

const CNAdvice = (
    // { orderProductId }: any
) => {
    // const [poDetails, setPoDetails] = useState<any>([]);

    // const fetchPoDetails = async () => {
    //     try {
    //         const response = await reconcilePoItem({
    //             order_product_id: orderProductId,
    //             company_code: 618
    //         });
    //         setPoDetails(response?.data?.data?.invoiceProductMappings);
    //     } catch (error) {
    //         console.log(error);
    //     }
    // }

    // useEffect(() => {
    //     fetchPoDetails();
    // }, [orderProductId])

    return (
        <div className="mt-2 text-center text-sm text-[#B5B5B5]">
            No data found
        </div>
    )
}

export default CNAdvice;
